export default "__VITE_ASSET__4d23afbd__"